import { tagStore, tagEdit, getTagsClass, tagDetail } from './request';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    isEdit: {
      type: [Boolean, Number, String],
      default: false,
      required: true
    }
  },
  data() {
    return {
      addForm: {
        tagsName: '',
        tagsClass: ''
      },
      saveLoading: false,
      classList: []
    };
  },
  watch: {
    visible(newV) {
      if (newV && this.$props.isEdit) {
        this.getDetail();
      }
    }
  },
  created() {
    this.getSelectList();
  },
  computed: {
    ADD_RULES() {
      return {
        tagsName: [{
          required: true,
          message: this.$t('请输入') + this.$t('标签名称'),
          trigger: 'blur'
        }, {
          message: '1-30字符',
          max: 30,
          min: 1
        }],
        tagsClass: [{
          required: true,
          message: '请选择分类',
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          if (this.$props.isEdit) {
            await tagEdit(this.addForm);
          } else {
            await tagStore(this.addForm);
          }
          this.$emit('save');
          this.closeAddVisible();
        }
      });
    },
    closeAddVisible(e) {
      this.$emit('cancel', e);
      this.resetForm();
    },
    async getSelectList() {
      this.classList = await getTagsClass({
        page: 1
      });
    },
    async getDetail() {
      const res = await tagDetail({
        tagsId: this.$props.isEdit
      });
      this.addForm.tagsId = res.id;
      this.addForm.tagsName = res.fieldKey;
      this.addForm.tagsClass = res.class;
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    }
  }
};